// 校验会员权益使用次数全局mixins
import { checkMemberBenefitUsage } from '@/utils/memberBenefitChecker'

export default {
	methods: {
		/**
		 * 便捷调用：带组件上下文的校验函数
		 * @param {string} memberBenefit - 权益标识
		 * @returns {Promise<boolean>}
		 */
		async validateMemberBenefit(memberBenefit) {
			return checkMemberBenefitUsage.call(this, memberBenefit) // 绑定组件上下文（this）
		}
	}
}
